/** Class for Document Details */
export class DocumentDetails {
	/**pan Verified By */
	panVerifiedBy: string;
	/** aadhar Verified By */
	aadharVerifiedBy: string;
	/** Unique Identifier for DTO */
	id: string;
	/** Boolean valiue if is E-KYC Submitted as Y/N */
	iseKYC: string;
	/** Unique Identifier for Investor */
	investorId: string;
	/** Pan Card File Name */
	panCardFileName: string;
	/** id Proof Type */
	idProofType: string;
	/** address Proof Type */
	addrProofType: string;
	/** Investor Photo File Name */
	photoFileName: string;
	/** Signature File Name */
	signFileName: string;
	/** Income Proof File Name */
	incomeProofFileName: string;
	/** Type of income Proof Uploaded */
	incomeProofType: string;
	/** Pan document */
	PAN_DOC: string;
	/** Cancelled Cheque File Name */
	chequeFileName: string;
	/** Pan Card File Name */
	aadhaarCardFile: string;
	/** Pan Card File Name */
	aadhaarPhotoFile: string;
	/** Bank Statement File Name */
	bankACStatmentFile: string;
	/** BackOffice PAN Card File Name */
	BOPanCardFileName: string;
	/** IPV Image File Name */
	IPVImage: string;
	/** OTP for IPV */
	IPVOtp: string;
	/** BOKRAPageFileName */
	BOKRAPageFileName: string;
	/** BOAddrProofFileName */
	BOAddrProofFileName: string;
	/** BOExtraDocFileName */
	BOExtraDocFileName: string;
	/** BOIncmProofFileName */
	BOIncmProofFileName: string;
	/** BOPanCardITWebFileName */
	BOPanCardITWebFileName: string;
	/** BOPOAPageFileName */
	BOPOAPageFileName: string;
	/** visaFileName */
	visaFileName: string;
	/** addrProofFrontFileName */
	addrProofFrontFileName: string;
	/** addrProofRearFileName */
	addrProofRearFileName: string;
	/** passportFrontFileName */
	passportFrontFileName: string;
	/** passportRearFileName */
	passportRearFileName: string;
	/** overseasAddressFrontFileName */
	overseasAddressFrontFileName: string;
	/** overseasAddressRearFileName */
	overseasAddressRearFileName: string;
	/** chequeFileNameApproveStatus */
	chequeFileNameApproveStatus: string;
	/** addrProofFileNameApproveStatus */
	addrProofFileNameApproveStatus: string;
	/** signFileNameApproveStatus */
	signFileNameApproveStatus: string;
	/** incomeProofFileNameApproveStatus */
	incomeProofFileNameApproveStatus: string;
	/** overseasAddressApproveStatus */
	overseasAddressApproveStatus: string;
	/** panCardFileNameApproveStatus */
	panCardFileNameApproveStatus: string;
	/** passportFileNameApproveStatus */
	passportFileNameApproveStatus: string;
	/** photoFileNameApproveStatus */
	photoFileNameApproveStatus: string;
	/** visaFileNameApproveStatus */
	visaFileNameApproveStatus: string;
	/** photoVerifiedBy */
	photoVerifiedBy: string;
	/** selfieGeoLocation */
	selfieGeoLocation: string;
	/** identifierNumber */
	identifierNumber:string;
	/** expiryDate */
	expiryDate:Date;

	/** Method to initialize Component */
	constructor() { }
}
